<template lang="pug">
Carousel
  .event-block(v-for="event in eventsArray")
    .title {{__(event.division, 'auto')}} {{__('Events', eventNamespace)}}
    .event-block-contents
      .date
        div {{event.date}}
        div {{event.time}}
      component.event-title(:is="event.link ? 'rogue-link' : 'div'" :to="event.link")
        | {{event.title}}
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { eventNamespace } from '../../js/constants'

interface CompetitionEvent {
  title: string
  division: string
  time: string
  eventId: string | number
  [key: string]: any
}

const props = withDefaults(defineProps<{
  events?: CompetitionEvent[]
  baseUrl?: string
  competition: Record<string, any>
  timeZone?: string 
}>(), {
  events   : () => [],
  baseUrl  : '',
  timeZone : '',
})

const eventsArray = computed(() => {
  const now = Date.now()
  const twoHoursAgo = now - (1000 * 60 * 60 * 2)
  // If there are upcoming events, the scroller should only show those
  const upcoming = (props.events || []).filter(e => new Date(e.time).getTime() > twoHoursAgo)

  const toShow = upcoming.length ? upcoming : (props.events || [])

  const timeZoneString = props.timeZone

  return toShow.map(e => {
    const eventDate = new Date(e.time)
    const isFuture = eventDate.getTime() > now

    return {
      title    : e.title,
      division : e.division.includes(' Events') 
        ? e.division.replace(' Events', '') 
        : e.division,
      link: isFuture 
        ? null 
        : `${props.baseUrl || ''}/${e.division}/${e.eventId}`.toLowerCase(),
      time: eventDate.toLocaleTimeString(undefined, { 
        hour     : 'numeric', 
        minute   : 'numeric', 
        timeZone : timeZoneString, 
      }),
      date: eventDate.toLocaleDateString(undefined, { 
        day      : 'numeric', 
        weekday  : 'long', 
        month    : 'long', 
        timeZone : timeZoneString, 
      }),
    }
  })
})
</script>
<style lang="scss" scoped>
.event-block {
  width: 308px;
  border: 1px solid $color-gray;
  margin-right: $space-s;

  &:last-child {
    margin-right: 0;
  }
}
.event-block-contents {
  padding: $space-s
}
.title {
  background-color: $color-black;
  padding: $space-xs;
  font-size: $size-xs;
  text-transform: uppercase;
  color: $color-white;
  font: $font-condensed;
  font-weight: $weight-bold;
}

.event-title {
  text-decoration: none;
  color: $color-black;
  font-family: $font-header;
  font-size: $size-l;
  text-transform: uppercase;
}

.date {
  display: flex;
  justify-content: space-between;
  margin-bottom: $space-s;
}
</style>
